var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="CDB-Widget-contentSpaced CDB-Widget-contentSpaced--end js-torque-controls"></div>\n<div class="CDB-Widget-contentFull">\n  <div class="js-time-series-header"></div>\n</div>\n';

}
return __p
}